import { formEl } from "./dom";
import { resetAllPreviews, setCardNumberPreview, setCardholderNamePreview, setCvcPreview, setExpireDatePreviewHandlers } from "./utils";

const { setMonthPreview, setYearPreview } = setExpireDatePreviewHandlers;

formEl.cardHolder.addEventListener("input", e => setCardholderNamePreview(e.target.value))
// TODO: Card number preview should use monospaced font
formEl.cardNumber.addEventListener("beforeinput", handleCardNumberBeforeInput)
formEl.expireMonth.addEventListener("beforeinput", handleOnlyDigitsBeforeInput)
formEl.expireMonth.addEventListener("input", e => setMonthPreview(e.target.value))
formEl.expireYear.addEventListener("beforeinput", handleOnlyDigitsBeforeInput)
formEl.expireYear.addEventListener("input", e => setYearPreview(e.target.value))
formEl.cvc.addEventListener("beforeinput", handleOnlyDigitsBeforeInput)
formEl.cvc.addEventListener("input", e => setCvcPreview(e.target.value))

formEl.confirmBtn.addEventListener("click", handleConfirmButtonClick)
formEl.continueBtn.addEventListener("click", handleContinueButtonClick)


function handleCardNumberBeforeInput(event) {
    const cardNumberStr = formEl.cardNumber.value
    const setCardNumber = (text) => formEl.cardNumber.value = text
    const currentLength = cardNumberStr.length

    function shouldProcessInput() {
        if (event.data === " ") {
            return false;
        }

        if (/\d/.test(event.data) === false) {
            return false;
        }

        const inputNoSpacesLength = cardNumberStr.replaceAll(' ', '').length
        if (inputNoSpacesLength === 16) {
            return false
        }

        return true;
    }

    if (event.inputType === "insertText") {
        event.preventDefault();

        if (shouldProcessInput() === false) {
            return
        }

        const inputNoSpacesLength = cardNumberStr.replaceAll(' ', '').length
        let valueToAdd = event.data

        // should insert a space after every 4 character but not after 16
        if (currentLength !== 0 && inputNoSpacesLength % 4 === 0) {
            valueToAdd = " " + event.data
        }

        const newInputValue = cardNumberStr + valueToAdd
        setCardNumber(newInputValue)
        setCardNumberPreview(newInputValue)
    }

    if (event.inputType === "deleteContentBackward") {
        event.preventDefault()

        let sliceEndIndex = currentLength - 1

        // TODO: Select all and remove don't work
        if (cardNumberStr.at(-2) === " ") {
            sliceEndIndex = currentLength - 2
        }

        const updatedCardNumberStr = cardNumberStr.slice(0, sliceEndIndex)
        setCardNumber(updatedCardNumberStr)
        setCardNumberPreview(updatedCardNumberStr)
    }

    if (event.inputType === "insertFromPaste") {
        event.preventDefault()

        const noWhitespaceEventData = event.data.replaceAll(" ", "")

        if (noWhitespaceEventData.length !== 16) return

        let formattedData = noWhitespaceEventData[0]

        for (let index = 1; index < noWhitespaceEventData.length; index++) {
            if (index % 4 === 0) {
                formattedData += " "
            }

            formattedData += noWhitespaceEventData[index]

        }

        setCardNumber(formattedData)
        setCardNumberPreview(noWhitespaceEventData)
    }
}

function handleOnlyDigitsBeforeInput(event) {
    if (event.inputType === "insertText") {
        if (/\d/.test(event.data) === false) {
            event.preventDefault()
            return
        }
    }
}

function handleConfirmButtonClick(event) {
    event.preventDefault()

    formEl.resetValidityStatus()

    const errors = validateForm()
    if (errors.length === 0)
        formEl.toggleStep()

    displayFormValidationErrors(errors)
}

function handleContinueButtonClick(event) {
    event.preventDefault()

    formEl.clear()
    resetAllPreviews()
    formEl.toggleStep()
}

function validateForm() {
    const cardNumberStr = formEl.cardNumber.value
    const cardHolderNameStr = formEl.cardHolder.value
    const expireMonthStr = formEl.expireMonth.value
    const expireYearStr = formEl.expireYear.value
    const cvcStr = formEl.cvc.value

    const errors = []

    if (cardHolderNameStr.trim() === "") {
        errors.push({ el: formEl.cardHolder, err: "Can't be blank" })
    }

    if (cardNumberStr.trim() === "") {
        errors.push({ el: formEl.cardNumber, err: "Can't be blank" })
    }
    else if (cardNumberStr.replaceAll(" ", "").length !== 16) {
        errors.push({ el: formEl.cardNumber, err: "Must be 16 digits" })
    }

    if (expireMonthStr.trim() === "") {
        errors.push({ el: formEl.expireMonth, err: "Can't be blank" })
    }
    else if (expireMonthStr.length !== 2) {
        errors.push({ el: formEl.expireMonth, err: "Must be 2 digits" })
    }

    if (expireYearStr.trim() === "") {
        errors.push({ el: formEl.expireYear, err: "Can't be blank" })
    }
    else if (expireYearStr.length !== 2) {
        errors.push({ el: formEl.expireYear, err: "Must be 2 digits" })
    }

    if (cvcStr.trim() === "") {
        errors.push({ el: formEl.cvc, err: "Can't be blank" })
    }

    return errors
}

function displayFormValidationErrors(errors) {
    errors.forEach(e => {
        const { el, err: errorStr } = e
        el.setCustomValidity(errorStr)
    });
}

